export default __webpack_public_path__ + "static/media/SN3-1.4ecb2fcd.jpg";